import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function Maintenance() {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(false);

  const checkStatus = async () => {
    if (isChecking) return;
    setIsChecking(true);
    try {
      await api.get('/courses'); // Lightweight check
      navigate('/'); 
    } catch (err: any) {
      // Still in maintenance
      setIsChecking(false);
    }
  };

  useEffect(() => {
    // Check immediately on load in case they refreshed the page
    checkStatus();

    // Background ping every 3 minutes (180,000 ms) to avoid hammering the server
    const interval = setInterval(checkStatus, 180000); 
    
    return () => {
      clearInterval(interval);
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-on-surface overflow-hidden relative">
      {/* Background Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-[120px] animate-pulse delay-1000" />

      <div className="relative z-10 w-full max-w-md bg-surface-container-low border border-outline-variant/10 rounded-[2.5rem] p-10 sm:p-12 shadow-2xl shadow-black/50 text-center animate-in fade-in slide-in-from-bottom-8 duration-700">
        <div className="w-20 h-20 bg-primary/10 text-primary rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-inner rotate-3 hover:rotate-0 hover:scale-105 transition-all duration-500">
          <span className="material-symbols-outlined text-4xl animate-bounce">build_circle</span>
        </div>
        
        <h1 className="text-3xl font-black mb-4 tracking-tight">Be Right Back</h1>
        <p className="text-sm text-slate-400 leading-relaxed mb-8 font-medium">
          Our systems are currently undergoing scheduled maintenance to improve your experience. We'll be back online shortly!
        </p>
        
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex items-center justify-center gap-3 text-xs font-bold uppercase tracking-widest text-primary bg-primary/10 py-3 px-6 rounded-2xl w-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            System Updating...
          </div>
        </div>

        <div className="mt-8 p-4 bg-primary/15 border border-primary/30 rounded-2xl flex items-start gap-3 text-left">
          <span className="material-symbols-outlined text-primary text-xl mt-0.5">info</span>
          <p className="text-sm text-on-surface font-bold leading-relaxed">
            When the maintenance is over, we will inform you in the community. Please be patient!
          </p>
        </div>
      </div>
      
      <p className="relative z-10 mt-8 text-xs font-bold text-slate-500 uppercase tracking-[0.2em]">
        HitClicks Academy
      </p>
    </div>
  );
}
